import Api from '@/services/Api';

const RECURSO = '/orcamento';
export default {
    buscarFinancasEixoSocial
};

function buscarFinancasEixoSocial () {
    return Api.get(`${RECURSO}/eixoSocial`);
}
